import {Action} from "redux";
import {GetAllClientBrowsingHistoryByClientRequest} from "../request/client_browsing_history_request";
import {IClientClientBrowsingHistoriesActionCreator} from "../action/client_client_browsing_histories_action";

interface IClientClientBrowsingHistoriesDispatcher {
    getAllClientBrowsingHistories(item: GetAllClientBrowsingHistoryByClientRequest): void;
}

class Dispatcher implements IClientClientBrowsingHistoriesDispatcher {

    constructor(private dispatch: (action: Action) => void,
        private actionCreator: IClientClientBrowsingHistoriesActionCreator) {

    }

    public getAllClientBrowsingHistories = (item: GetAllClientBrowsingHistoryByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetAllClientBrowsingHistoriesAction(item));
    }

}

const createClientClientBrowsingHistoriesDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientClientBrowsingHistoriesActionCreator): IClientClientBrowsingHistoriesDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientClientBrowsingHistoriesDispatcher, createClientClientBrowsingHistoriesDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_client_browsing_histories_dispatcher.ts